export default __webpack_public_path__ + "static/media/dutch.4f35b4a6.png";